'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface MHTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const MHTextarea = React.forwardRef<HTMLTextAreaElement, MHTextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full min-h-[140px] resize-y rounded-[18px] bg-surface-2 px-4 py-4 text-body leading-[1.55] text-text-primary caret-ring md:min-h-[180px]',
          'placeholder:text-text-tertiary',
          'focus-visible:outline-none focus-visible:[box-shadow:var(--mh-focus-ring)] focus-visible:ring-offset-0',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      />
    );
  }
);

MHTextarea.displayName = 'MHTextarea';

export { MHTextarea };
